import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fast-text-encoding/text';
import 'core-js';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/stable';
import 'core-js/features/string/repeat';
import 'raf/polyfill';
import 'regenerator-runtime';
import fetch from 'isomorphic-fetch';
import 'es6-promise';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ApolloClient } from 'apollo-client';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from '@apollo/react-hooks';
import { AuthProvider } from 'contexts/authContext';
import { isAuthenticated, getToken } from 'utils/auth';
import { BrowserRouter } from 'react-router-dom';
import theme from './theme';
import { ThemeProvider } from 'styled-components/macro';
import GlobalStyle from './GlobalStyle';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import { createUploadLink } from 'apollo-upload-client';

// Commenting out service worker, see comment below.
//import * as serviceWorker from './serviceWorker';

const httpLink = createUploadLink({
  uri: process.env.REACT_APP_API_URL + '/graphql',
  headers: {},
});

const authLink = setContext((_, { headers }) => {
  let modifiedHeaders = headers || {};

  if (isAuthenticated()) {
    modifiedHeaders['Authorization'] = `Bearer ${getToken()}`;
  }

  return { headers: modifiedHeaders };
});

const client = new ApolloClient({
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    },
    mutation: {
      fetchPolicy: 'no-cache',
    },
  },
  fetch,
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

const ReactApp = () => (
  <ThemeProvider theme={theme}>
    <ApolloProvider client={client}>
      <AuthProvider>
        <BrowserRouter>
          <GlobalStyle />
          <App />
        </BrowserRouter>
      </AuthProvider>
    </ApolloProvider>
  </ThemeProvider>
);

ReactDOM.render(<ReactApp />, document.getElementById('root'));

// * Commenting out servicework code.  This will probably be needed in production, but causes issues
// * doing QA.
// ** If you want your app to work offline and load faster, you can change
// ** unregister() to register() below. Note this comes with some pitfalls.
// ** Learn more about service workers: https://bit.ly/CRA-PWA
//    serviceWorker.unregister();
